import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["statusMessage", "progressBar", "progressPercent", "candidateCount", "motivationalMessage"]

  connect() {
    this.startProgress()
    this.rotateMessages()
  }

  disconnect() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval)
    }
    if (this.messageInterval) {
      clearInterval(this.messageInterval)
    }
  }

  startProgress() {
    let progress = 0
    let candidateCount = 0
    const maxCandidates = 5000 // Geschätzte maximale Anzahl
    const incrementSpeed = 2 // Prozent pro Update
    const candidateIncrement = 50 // Kandidaten pro Update
    
    // Starte sofort mit einem kleinen Wert
    if (this.hasCandidateCountTarget) {
      this.candidateCountTarget.textContent = '0'
    }

    // Motivierende Statusnachrichten
    const statusMessages = [
      "Suche nach passenden Kandidaten...",
      "Analysiere Kompetenzen...",
      "Berechne Match-Scores...",
      "Filtere Ergebnisse...",
      "Fast fertig..."
    ]

    const motivationalMessages = [
      "Wir durchsuchen unsere Datenbank nach den besten Kandidaten für Sie...",
      "Die KI analysiert Profile und findet optimale Matches...",
      "Wir vergleichen Kompetenzen und Erfahrungen...",
      "Fast fertig! Die besten Kandidaten werden geladen...",
      "Qualität braucht Zeit - wir finden die perfekten Matches..."
    ]

    let messageIndex = 0
    let motivationalIndex = 0

    this.progressInterval = setInterval(() => {
      // Fortschritt langsam erhöhen (max. 90%, damit es nicht vollständig wird)
      if (progress < 90) {
        progress += incrementSpeed
        if (progress > 90) progress = 90
      }

      // Kandidatenanzahl erhöhen
      if (candidateCount < maxCandidates) {
        candidateCount += candidateIncrement
        if (candidateCount > maxCandidates) candidateCount = maxCandidates
      }

      // Fortschrittsanzeige aktualisieren
      if (this.hasProgressBarTarget) {
        this.progressBarTarget.style.width = `${progress}%`
      }
      if (this.hasProgressPercentTarget) {
        this.progressPercentTarget.textContent = `${Math.round(progress)}%`
      }
      if (this.hasCandidateCountTarget) {
        const formattedCount = candidateCount.toLocaleString('de-DE')
        this.candidateCountTarget.textContent = formattedCount
      }

      // Statusnachrichten rotieren (alle 20%)
      if (Math.floor(progress / 20) !== messageIndex && messageIndex < statusMessages.length - 1) {
        messageIndex = Math.floor(progress / 20)
        if (this.hasStatusMessageTarget) {
          this.statusMessageTarget.textContent = statusMessages[messageIndex] || statusMessages[statusMessages.length - 1]
        }
      }
    }, 200) // Alle 200ms aktualisieren
  }

  rotateMessages() {
    const motivationalMessages = [
      "Wir durchsuchen unsere Datenbank nach den besten Kandidaten für Sie...",
      "Die KI analysiert Profile und findet optimale Matches...",
      "Wir vergleichen Kompetenzen und Erfahrungen...",
      "Fast fertig! Die besten Kandidaten werden geladen...",
      "Qualität braucht Zeit - wir finden die perfekten Matches..."
    ]

    let index = 0

    this.messageInterval = setInterval(() => {
      if (this.hasMotivationalMessageTarget) {
        this.motivationalMessageTarget.textContent = motivationalMessages[index]
        index = (index + 1) % motivationalMessages.length
      }
    }, 3000) // Alle 3 Sekunden wechseln
  }
}

